import moment from 'moment-timezone';

// timezone padrão do sistema
export const TZ = 'America/Sao_Paulo';

// helper principal (igual backend)
export const m = (date, format = null) =>
  format
    ? moment.tz(date, format, TZ)
    : moment.tz(date, TZ);

// helper opcional já formatando (facilita no JSX)
export const formatHora = (date, format = 'HH:mm:ss') =>
  date ? m(date).format(format) : '';

export const formatDate = (date, format = 'DD/MM') =>
  date ? m(date).format(format) : '';

export const formatDateTime = (value, forExcel = false) => {

  if (!value) {
    return ' - ';
  }

  const separator = forExcel
    ? ' - '
    : '\n';

  return `${formatDate(value)}${separator}${formatHora(value)}`;
};

export const combineDateTime = (date, time) => {
  if (!date || !time) return null;

  return m(
    `${m(date).format('YYYY-MM-DD')} ${time}`,
    'YYYY-MM-DD HH:mm'
  );
};

function isBetweenDates(date, start, end) {
  return m(date).isBetween(
    m(start),
    m(end),
    undefined,
    '[]'
  );
}

export function isWithinTripRange(date, start, end, toleranceMinutes = 0) {

  return isBetweenDates(
    date,
    start,
    m(end).add(toleranceMinutes, 'minutes')
  );

}

// =========================

const feriadosFixos = [
  '01-01','04-21','05-01','09-07','10-12','11-02','11-15','12-25'
];

export function isFeriado(date) {
  const mmdd = m(date).format('MM-DD');
  return feriadosFixos.includes(mmdd);
}

export function getDayContext(date = null, offset = 0) {
  
  const base = date
    ? m(date).add(offset, 'days')
    : m().add(offset, 'days');

  const dias = [
    'DOMINGO',
    'SEGUNDA',
    'TERCA',
    'QUARTA',
    'QUINTA',
    'SEXTA',
    'SABADO'
  ];

  const diasNome = [
    'DOMINGO',
    'SEGUNDA',
    'TERÇA',
    'QUARTA',
    'QUINTA',
    'SEXTA',
    'SÁBADO'
  ];

  const dayIndex = base.day();
  const isHoliday = isFeriado(base);

  const nome = isHoliday
    ? 'FERIADO'
    : diasNome[dayIndex];

  return {
    date: base,
    dayIndex,
    nome,
    flag: isHoliday
      ? 'FLG_FERIADO'
      : `FLG_${dias[dayIndex]}`,
    isHoliday
  };
}

export function getOperationalContext(now = m()) {

  const currentHour = now.hour();

  // Madrugada pertence ao turno iniciado no dia anterior
  if (currentHour < 8) {

    return {
      date: now.clone().subtract(1, 'day'),
      hourRange: [20, 32]
    };

  }

  // Turno diurno
  if (currentHour < 20) {

    return {
      date: now.clone(),
      hourRange: [8, 20]
    };

  }

  // Turno noturno
  return {
    date: now.clone(),
    hourRange: [20, 32]
  };
}

export function getDefaultHourRange(
  hourRangePerm = {},
  now = m()
) {

  const {
    minHour = 0,
    maxHour = 23,
    useOperationalRange = false
  } = hourRangePerm;

  if (!useOperationalRange) {

    return [
      Math.max(now.hour(), minHour),
      maxHour
    ];

  }

  return getOperationalContext(now).hourRange;
}

export function isTripInHourRange(
  trip,
  [startHour, endHour],
  selectedDate
) {

  const tripStart = m(trip.DATAHORA_INICIAL_PREVISTO);
  const tripEnd = m(trip.DATAHORA_FINAL_PREVISTO);

  const baseDate = m(selectedDate).startOf('day');

  const rangeStart = baseDate.clone()
    .add(startHour, 'hours');

  const rangeEnd = baseDate.clone()
    .add(endHour, 'hours');

  return (
    tripStart.isSameOrBefore(rangeEnd) &&
    tripEnd.isSameOrAfter(rangeStart)
  );
}

export const formatSeconds = (totalSeconds) => {
  const seconds = Math.round(Number(totalSeconds));

  if (!Number.isFinite(seconds)) {
    return '-';
  }

  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes}m${remainingSeconds}s`;
};

export function getNextOperationalChange(now = m()) {

  const next = now.clone();

  if (now.hour() < 8) {

    return next
      .hour(8)
      .minute(0)
      .second(0)
      .millisecond(0);

  }

  if (now.hour() < 20) {

    return next
      .hour(20)
      .minute(0)
      .second(0)
      .millisecond(0);

  }

  return next
    .add(1, 'day')
    .hour(8)
    .minute(0)
    .second(0)
    .millisecond(0);
};

export const getTempoPercurso = (
  inicio,
  fim
) => {

  if (!inicio || !fim) {
    return null;
  }

  const start = m(inicio);
  const end = m(fim);

  if (
    !start.isValid() ||
    !end.isValid() ||
    end.isBefore(start)
  ) {
    return null;
  }

  const minutos = end.diff(start, 'minutes');

  const horas = Math.floor(minutos / 60);
  const minutosRestantes = minutos % 60;

  return `${String(horas).padStart(2, '0')}h ${String(minutosRestantes).padStart(2, '0')}min`;

};